__turbopack_context__.v({
  "action": "empty-state-module__DfKJ1a__action",
  "icon": "empty-state-module__DfKJ1a__icon",
  "iconCircle": "empty-state-module__DfKJ1a__iconCircle",
  "iconCircleCompact": "empty-state-module__DfKJ1a__iconCircleCompact",
  "iconCompact": "empty-state-module__DfKJ1a__iconCompact",
  "text": "empty-state-module__DfKJ1a__text",
  "textCompact": "empty-state-module__DfKJ1a__textCompact",
  "title": "empty-state-module__DfKJ1a__title",
  "titleCompact": "empty-state-module__DfKJ1a__titleCompact",
  "wrapper": "empty-state-module__DfKJ1a__wrapper",
  "wrapperCompact": "empty-state-module__DfKJ1a__wrapperCompact",
});
